export class Logout {
}